module.exports = __webpack_public_path__ + "img/dynalogo.d554c792.svg";